import { useContext } from "react";
import { UserContext } from "shared/context/UserContext";
import { useQuery } from "@tanstack/react-query";
import { GetObjectHashValue } from "shared/helpers/DataHelpers";

export function useFetchParentCompanies() {
  const userContext = useContext(UserContext);
  const dataKey = "useFetchParentCompaniesResultKey";

  async function getParentCompanies() {
    try {
      // Filter parent companies from the organizations array
      const parentCompanies = userContext.organizations
        .filter((org) => org.type === "ParentCompany")
        .map((pc) => ({
          label: pc.labelNoSuffix,
          value: pc.value,
        }));

      // Sort parent companies alphabetically by label
      return parentCompanies.sort((p1, p2) =>
        p1.label > p2.label ? 1 : p1.label < p2.label ? -1 : 0
      );
    } catch (error) {
      console.error("Error fetching parent companies:", error);
      // Properly handle the error to maintain the stack trace
      throw error instanceof Error ? error : new Error(String(error));
    }
  }

  function isEnabled() {
    if (
      !userContext ||
      !userContext.organizations ||
      userContext.organizations.length === 0
    ) {
      return false;
    }

    return true;
  }

  function organizationsHash() {
    if (!isEnabled()) return "";

    let organizationsHash = GetObjectHashValue(userContext.organizations);

    return organizationsHash;
  }

  return useQuery({
    queryKey: [dataKey, organizationsHash()],
    queryFn: async () => await getParentCompanies(),
    enabled: isEnabled(),
  });
}
